import {isEqual} from 'lodash-es';
import {MyVerbale} from '../models/interfaces/revisione.interface';

export interface SectionFormServiceRef {
    readonly dependencyPaths: Set<string>;
    refreshFormData(): void;
}

const getNestedValue = (obj: unknown, path: string): unknown => {
    return path.split('.').reduce((acc: Record<string, unknown>, key: string) => acc?.[key], obj);
};

export const computeChangedSections = (prev: MyVerbale, curr: MyVerbale, paths: string[]): string[] => {
    return paths.filter((path) => !isEqual(getNestedValue(prev, path), getNestedValue(curr, path)));
};
